import { render, staticRenderFns } from "./WwsStudentSpecificIcardPrint.vue?vue&type=template&id=0e34f992&scoped=true&"
import script from "./WwsStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
export * from "./WwsStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./WwsStudentSpecificIcardPrint.vue?vue&type=style&index=0&id=0e34f992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34f992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
